$(function () {
    $('.lose-modal__overlay, .lose-modal__close').on('click', function(e){
        e.preventDefault();

        $('.lose-modal__overlay, .lose-modal').removeClass('active');

    });
});
